// removed by extract-text-webpack-plugin
module.exports = {"container":"FY4SvVEGj2vV8SJsNOpuG","title":"_2WOPGto7g_3wvLvjfoWhk3","noTable":"C9C7INgpyhIuHUMb8sd87","packbtn":"_3QsXbF_pYBrmK1WCj7I2CC"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Settings/Payments/AvailablePacks/styles.css
// module id = 2655
// module chunks = 0